import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar";
import Header from "../../component/loaderComponent/Header/Header";
import "./scanlimit.scss";
import { useDispatch } from "react-redux";
import { scanListAction, postscanlistAction } from "../../actions/redemptionAction";
import { notify } from '../../services/notification';
import Validation from "../../constants/validation/Validation";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import { HTTP_STATUS } from "../../constants/httpsStatus/httpsStatus";
import { HiMenu, HiX } from "react-icons/hi";
import moment from 'moment';
import useMobileView from "../../constants/useMobileView";

function ScanLimit() {
  const [states, setStates] = useState({
    monthly_scan_limit: "",
    daily_scan_limit: ""
  });
  const [scanlimit, setScanLimit] = useState([]);

  const [loading, setloading] = useState(false);
  const { isSidebarOpen, toggleSidebar } = useMobileView();

  const dispatch = useDispatch();

  useEffect(() => {
    getScanLimit();
  }, []);



  const handleChange = (evt) => {
    const { name, value } = evt.target;
    setStates({
      ...states,
      [name]: value.replace(/^ +/gm, ""),
    });
  };

  async function getScanLimit() {
    setloading(true);
    var response = await dispatch(scanListAction());
    if (response?.status === HTTP_STATUS.SUCCESS) {
      setScanLimit(response?.data?.data);
    }
    setloading(false);
  }

  const handleOnCreateClick = async () => {
    if (parseInt(states.monthly_scan_limit, 10) <= parseInt(states.daily_scan_limit, 10)) {
      notify.error("Monthly limit must be greater than daily limit");
      return;
    }

    setloading(true);
    const apiReq = {
      daily_scan_limit: parseInt(states?.daily_scan_limit, 10) || 0,
      monthly_scan_limit: parseInt(states?.monthly_scan_limit, 10) || 0
    };

    let response = await dispatch(postscanlistAction(apiReq));

    if (response?.status === HTTP_STATUS.SUCCESS) {
      notify.success(response?.data?.message);
      setStates({ daily_scan_limit: "", monthly_scan_limit: "" });
      setTimeout(() => {
        getScanLimit();
      }, 400);
    }

    setloading(false);
  };



  return (
    <div className="scan-limit-container">
      <div className="scan-limit-rightsidebar">
        <Header title="Scan Limit" />
        {loading ? <Loader /> : (
          <div className="scan-limit-input-label">
            <div className="scan-search">
              <div className="scan-label">
                <div className="scan-input-lable">
                  <label className="label-scan-limit">Monthly Limit</label>
                  <input type="text" className="scan-limit-input" maxLength={3} placeholder="Add Monthly limit" name="monthly_scan_limit" value={states.monthly_scan_limit} onChange={handleChange} onKeyPress={(e) => Validation.numberinputValidator(e)} />
                </div>
                <div className="scan-input-lable">
                  <label className="label-scan-limit">Daily Limit</label>
                  <input type="text" className="scan-limit-input" maxLength={3} placeholder="Add Daily limit" name="daily_scan_limit" value={states.daily_scan_limit} onChange={handleChange} onKeyPress={(e) => Validation.numberinputValidator(e)} />
                </div>
                <div className="scan-create">
                  <button
                    type="button"
                    className="scan-limit-create-button"
                    onClick={handleOnCreateClick}
                    disabled={!states.daily_scan_limit || !states.monthly_scan_limit}
                  >
                    Create
                  </button>
                </div>
              </div>
            </div>
            <div className="table-scan-limit">
              <table className="table">
                <thead>
                  <tr>
                    <th className="tablesth">Daily Scan Limit</th>
                    <th className="tablesth">Monthly Scan Limit</th>
                    <th className="tablesth">Created on</th>
                    <th className="tablesth">Created by</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="tabletd">{scanlimit?.daily_scan_limit}</td>
                    <td className="tabletd">{scanlimit?.monthly_scan_limit}</td>
                    <td className="tabletd">{moment(scanlimit?.created_at).utc().format('DD/MM/YYYY')}</td>
                    <td className="tabletd">{scanlimit?.admin_user_name}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ScanLimit;
